import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: {
    key: `ContextList-title`,
    defaultValue: `Crie nichos a partir de um contexto específico:`,
  },
  titleTotal: {
    key: `ContextList-titleTotal`,
    defaultValue: `Descubra nichos a partir de um contexto específico:`,
  },
  createNewContext: {
    key: `ContextList-createNewContext`,
    defaultValue: `Criar novo contexto`,
  },
})
